import { useMemo } from "react"
import { HH, RABOTA, SUPER_JOB, TRUD_VSEM, TSource } from "../utils"
import HHIcon from '../assets/HH.svg'
import SuperJobIcon from '../assets/SuperJob_Main.svg'
import RabotaIcon from '../assets/Rabota.svg'
import TrudVsemIcon from '../assets/TrudVsem.svg'


const useGetIcon = (source: TSource) => {
  const icon = useMemo(() => {
    switch (source) {
      case HH:
        return HHIcon
      case SUPER_JOB:
        return SuperJobIcon
      case RABOTA:
        return RabotaIcon
      case TRUD_VSEM:
        return TrudVsemIcon
    }
  }, [source])
  
  return icon
}

export default useGetIcon